// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.federated-signin {
    margin-top: 0.5rem;
}

    .federated-signin > button > svg {
        margin-right: 0.5rem;
        height: 1.5rem;
        width: 1.5rem;
    }
`, "",{"version":3,"sources":["webpack://./src/Account/css/AccountFederatedSignIn.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;IAEI;QACI,oBAAoB;QACpB,cAAc;QACd,aAAa;IACjB","sourcesContent":[".federated-signin {\r\n    margin-top: 0.5rem;\r\n}\r\n\r\n    .federated-signin > button > svg {\r\n        margin-right: 0.5rem;\r\n        height: 1.5rem;\r\n        width: 1.5rem;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
